import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { ReportStatusBadge } from '$features/report-hub/components/report-status-badge';
import { StabilityReportDetailModel } from '$features/report-hub/stability-report/stability-report.types';

interface StabilityReportSidecarHeaderProps {
  report?: StabilityReportDetailModel;
}

export function StabilityReportSidecarHeader({
  report,
}: StabilityReportSidecarHeaderProps): ReactElement {
  const { t } = useTranslation();

  return (
    <div className="sidecar__masthead m-bottom-xl">
      <div className="sidecar__device-detail-header gap-m">
        <h2 className="font-weight-bold font-size-xxl">
          {t('reportHub.stabilityReport')}
        </h2>
        {report && <ReportStatusBadge status={report.status} bordered />}
      </div>
    </div>
  );
}
